import { Stack } from "@mui/material";
import { PropsWithChildren } from "react";
import { Outlet } from "react-router-dom";

import { PrimaryNavigationContentLoader } from "../nav/components/PrimaryNavigation/components/PrimaryNavigationContent/PrimaryNavigationContentLoader";
import { PrimaryNavigation } from "../nav/components/PrimaryNavigation/PrimaryNavigation";
import { Content } from "./Layout";

export const LayoutMinimal = (props: PropsWithChildren) => {
  const { children = <Outlet /> } = props;

  return (
    <Stack direction="row" sx={{ overflow: "hidden" }}>
      <PrimaryNavigation>
        <PrimaryNavigationContentLoader />
      </PrimaryNavigation>
      <Content id="page-content">{children}</Content>
    </Stack>
  );
};
